import { User } from './user';
import { HttpClient, HttpXhrBackend } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';



export class AppEnviroment {
   static ApiEndPoint: string;
   static DiagramUrl: string;
   static BSPEndPoint: string;
   static BSPApiKey: string;
   static BSPUser: string;
   static BSPPassword: string;
   
   static get User (): User {
      if (localStorage.getItem("u"))
         return  JSON.parse(atob( localStorage.getItem("u")));
      else
         return new User();   
               
   }

   static set User(user: User) {
      localStorage.setItem("u", btoa(JSON.stringify(user)));
   }


   static IsConnected(): boolean {
      return true;
   }

   static LoadConfiguration() {
      const httpClient = new HttpClient(new HttpXhrBackend({ build: () => new XMLHttpRequest() }));
      const jsonFile = `assets/config.json`;
      return new Promise<void>((resolve, reject) => {
        httpClient.get(jsonFile).toPromise().then((response) => {
          var result: any = response;
          AppEnviroment.ApiEndPoint = result.ApiEndPoint;
          AppEnviroment.DiagramUrl = result.DiagramUrl;
          AppEnviroment.BSPEndPoint = result.BSPEndPoint;
          AppEnviroment.BSPApiKey = result.BSPApiKey;
          AppEnviroment.BSPUser = result.BSPUser;
          // Decodificar Base64
          AppEnviroment.BSPPassword = atob(result.BSPPassword);
          resolve();
        }).catch((response: any) => {
          reject(`No puede cargar el archivo de configuración: ' ${JSON.stringify(response)}`);
        });
      });
    }
    
    static CloseSession()
    {
      localStorage.clear();
    }

    static Translate:TranslateService;

}


